module.exports = __webpack_public_path__ + "img/turkish-pothole.f9c23b1b.png";